export enum restaurantListDataActionsTypes {
  GET_RESTAURANT_LIST_REQUEST = 'GET_RESTAURANT_LIST_REQUEST',
  GET_RESTAURANT_LIST_SUCCESS = 'GET_RESTAURANT_LIST_SUCCESS',
  GET_RESTAURANT_LIST_FAILURE = 'GET_RESTAURANT_LIST_FAILURE',

  GET_NEARBY_RESTAURANT_LIST_REQUEST = 'GET_NEARBY_RESTAURANT_LIST_REQUEST',
  GET_NEARBY_RESTAURANT_LIST_SUCCESS = 'GET_NEARBY_RESTAURANT_LIST_SUCCESS',
  GET_NEARBY_RESTAURANT_LIST_FAILURE = 'GET_NEARBY_RESTAURANT_LIST_FAILURE',
}
